
import { useEffect, useState } from "react";
import { Grid, MenuItem, TextField } from "@mui/material"
import { useTodasUnidadesMedida } from "../../../hooks/cache/ui/useUnidadesMedida";
import { BotonesAndCargando } from "../../components/botones";
import { useInventarioStore } from "../../../stores";
import { useQueryClient } from "@tanstack/react-query";
import { crearNuevoInventario } from "../../../services";
import { AutocompleteMultiple } from "../../components";
import { useProveedoresSelect } from "../../../hooks/cache";

import Swal from "sweetalert2";




export const FormCrearProdcutoStock = ({ handleCerrarModalInv }) => {


    const queryClient = useQueryClient();
    const { activarInventario } = useInventarioStore();
    const { data, isLoading } = useTodasUnidadesMedida();
    const { data:proveedoresList } = useProveedoresSelect();
    // const millares = NumberFormatCustom;
    const [cargando, setCargando] = useState(false);
    

    const [ formInventario, setFormInventario ] = useState({ medida:"", nombre:"", cantidad:"", proveedores:[] });
    const { medida, nombre, cantidad, proveedores } = formInventario;
    const handleInputChange = ({ target }) => {
        setFormInventario({
            ...formInventario,
            [target.name]: target.value
        });
    }


    useEffect(() => {
        if( activarInventario ) {
            setFormInventario(items => ({
                ...items,
                ...activarInventario,
                medida: activarInventario?.medida?.id ?? ''
            }));
        }
    }, [activarInventario])


    
    const handleCrearInventario = async(e) => {
        e.preventDefault();
        if( [medida, nombre, cantidad].includes('') ) {
            return Swal.fire('Error', 'Todos los campos son obligatorios', 'error');
        }
        setCargando(true);
        const resp = await crearNuevoInventario({ ...formInventario, id:activarInventario?._id });
        setCargando(false);

        if( resp ){
            queryClient.invalidateQueries({ queryKey: ['todo-inventario'] });
            setFormInventario({ medida: "", nombre: "", cantidad: "" });
            handleCerrarModalInv();
        }
    }



    return (

        <form  onSubmit={ handleCrearInventario }>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        label="Nombre Producto"
                        type='text'
                        fullWidth
                        placeholder='Nombre Producto'
                        name="nombre"
                        value={ nombre }
                        onChange={ handleInputChange }
                        size="small"
                    >
                    </TextField>
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label="Cantidad"
                        type='number'
                        fullWidth
                        placeholder='Cantidad'
                        name="cantidad"
                        value={ cantidad }
                        onChange={ handleInputChange }
                        size="small"
                    >
                    </TextField>
                </Grid>

                {/* <Grid item xs={12}>
                    <TextField 
                        variant="outlined"
                        label='Precio Sin Iva'
                        placeholder='Precio Sin Iva'
                        fullWidth
                        name="precio"
                        value={ precio }
                        onChange={ handleInputChange }
                        InputProps={{ inputComponent: millares }}
                        size="small"
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField 
                        type="number"
                        variant="outlined"
                        label='Porcentaje Iva'
                        placeholder='Porcentaje Iva'
                        fullWidth
                        name="iva"
                        value={ iva }
                        onChange={ handleInputChange }
                        size="small"
                    />
                </Grid> */}

                <Grid item xs={12}>
                    <TextField
                        select
                        label="Unidad de Medida"
                        fullWidth
                        name="medida"
                        value={isLoading ? '' : formInventario.medida || ''}
                        onChange={ handleInputChange } 
                        size="small" 
                    >    
                        <MenuItem value=''>Seleccione Unidad de Medida</MenuItem>
                        {data?.map( (m) => (
                            <MenuItem value={m.id} key={m.id}>{ m.nombre }</MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12}>
                    <AutocompleteMultiple
                        name="proveedores"
                        label="Proveedores"
                        options={proveedoresList}
                        value={proveedores}
                        onChange={ handleInputChange }
                        size='small'
                    />
                </Grid>
                
            </Grid>

            <Grid container sx={{mb:2, mt:3, display:'flex', justifyContent:'center' }}>
                <Grid item xs={12} sm={6} md={5}>
                    <BotonesAndCargando
                        cargando={cargando}
                        titulo={`${(activarInventario) ? 'Editar' : 'Crear' } Producto`}
                        titulo2="Loading..."
                        icon1="save"
                        icon2="save"
                        esSubmit
                    />
                </Grid>
            </Grid>

        </form>
    )



}
